import { createFileRoute } from "@tanstack/react-router";
import { LocationPage, locationJsonLd } from "@/components/LocationPage";

export const config = {
  slug: "muzaffarnagar",
  tagline:
    "Healic Multispeciality Hospital on Circular Road brings trusted, affordable care closer to families across Muzaffarnagar.",
  hours: "Please call to confirm current opening hours",
  highlights: [
    "Convenient Civil Lines South location",
    "Multispecialty consultations and planned surgery care",
    "Transparent, affordable treatment",
    "Serving Muzaffarnagar and nearby communities",
  ],
  faqs: [
    {
      q: "Where is Healic Hospital Muzaffarnagar?",
      a: "The hospital is at 37/10, Circular Road, Santosh Vihar, Civil Lines South, Muzaffarnagar, Uttar Pradesh 251001.",
    },
    {
      q: "How can I book an appointment?",
      a: "Call Healic on +91 95887 95887 to confirm doctor availability and book your appointment.",
    },
    {
      q: "Does the hospital offer planned surgery care?",
      a: "Yes. Healic coordinates consultations, diagnostics, admission and recovery support for planned procedures.",
    },
    {
      q: "Which areas does this hospital serve?",
      a: "The hospital serves Civil Lines, Santosh Vihar and families across Muzaffarnagar and nearby communities.",
    },
  ],
};

export const Route = createFileRoute("/locations/muzaffarnagar")({
  head: () => ({
    meta: [
      { title: "Healic Hospital Muzaffarnagar — Multispeciality Care" },
      {
        name: "description",
        content:
          "Healic Multispeciality Hospital at 37/10 Circular Road, Civil Lines South, Muzaffarnagar. Call +91 95887 95887 for appointments.",
      },
      { property: "og:title", content: "Healic Multispeciality Hospital Muzaffarnagar" },
      {
        property: "og:description",
        content: "Trusted multispecialty consultations and planned surgery care in Muzaffarnagar.",
      },
      { property: "og:url", content: "https://healic.in/locations/muzaffarnagar" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://healic.in/locations/muzaffarnagar" }],
    scripts: locationJsonLd(config),
  }),
  component: () => <LocationPage config={config} />,
});
